// Field-scoped free-text search for a register: [Any field ▾] [🔍 Search … ×].
//
// Extracted from the Deliveries board's search row when the Receive-pallets
// register asked for the same control (CLAUDE.md: >5 copied lines of UI
// become a component). The FIELD LIST is the page's own — its values and the
// matching rule live beside the page's filter predicate
// (deliveriesFilter.ts / palletReceiptsFilter.ts); this only renders it.
// The first entry is expected to be the "Any field" sweep (value 'any').
import { Search, X } from 'lucide-react'

export default function FieldScopedSearch<F extends string>({
  fields, field, onField, query, onQuery, noun,
}: {
  fields: readonly { value: F; label: string }[]
  field: F
  onField: (f: F) => void
  query: string
  onQuery: (q: string) => void
  /** What "Any field" searches — "deliveries", "receipts" — for the placeholder. */
  noun: string
}) {
  const current = fields.find(f => f.value === field)
  const placeholder = !current || current.value === 'any'
    ? `Search ${noun}…`
    : `Search ${current.label.toLowerCase()}…`
  return (
    <div className="px-4 py-2 border-b hairline surface-sunk flex items-center gap-2">
      <select
        aria-label="Search field"
        value={field}
        onChange={e => onField(e.target.value as F)}
        className="surface border hairline-strong rounded-lg px-2 py-1.5 text-xs text-white light:text-fg shrink-0">
        {fields.map(f => (
          <option key={f.value} value={f.value}>{f.label}</option>
        ))}
      </select>
      <div className="relative flex-1">
        <Search size={14} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-muted pointer-events-none" />
        <input
          type="text"
          value={query}
          onChange={e => onQuery(e.target.value)}
          placeholder={placeholder}
          aria-label="Search text"
          className="w-full surface border hairline-strong rounded-lg pl-7 pr-7 py-1.5 text-xs text-white light:text-fg placeholder-gray-500"
        />
        {query && (
          <button
            type="button"
            onClick={() => onQuery('')}
            className="absolute right-0 top-1/2 -translate-y-1/2 min-w-[44px] min-h-[44px] flex items-center justify-center text-muted hover:text-fg-secondary"
            aria-label="Clear search">
            <X size={14} />
          </button>
        )}
      </div>
    </div>
  )
}
